import React, { useEffect, useState, useRef } from "react";
import { useLocation, useParams } from "react-router-dom";
import moment from "moment";
import { API } from "../../config/api";
import { ApiHelper } from "../../helpers/ApiHelper";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import eye from "../../assets/images/eye.png";
import eyeview from "../../assets/images/view.png";

const W4form = ({ review, data, fetchSections }) => {
  console.log(review, data);
  const params = useParams();
  const location = useLocation();
  const [tempId, setTempId] = useState(0);
  const [loader, setLoader] = useState(false);
  const [fields, setFields] = useState([]);
  const [formId, setFormId] = useState(data?.id);
  const [formData, setFormData] = useState([]);
  const [isReview, setIsReview] = useState(review);
  const [error, setError] = useState(false);
  const [fileName, setFilename] = useState("");

  useEffect(() => {
    // getFields();
    setData();
    getFileName();
    if (location.state?.tempId !== null) {
      setTempId(location?.state?.tempId);
    }
  }, [data]);

  // set value to formData
  const setData = () => {
    let arr = [];
    data?.fields?.map((item) => {
      let obj = {};
      if (item.field_label === "w4_ss_NO") {
        obj = {
          label: item.field_label,
          answer: item.interviewee_answer,
          isShow: false,
        };
      } else {
        obj = {
          label: item.field_label,
          answer: item.interviewee_answer,
        };
      }
      arr.push(obj);
    });
    console.log(arr);
    setFormData(arr);
  };

  const getFields = async () => {
    setLoader(true);
    const obj = {
      template_type: "w4-form",
    };
    await ApiHelper.post(API.getFields, obj)
      .then((resData) => {
        console.log(resData);
        setFields(resData?.data?.fields);
      })
      .catch((err) => {
        setLoader(false);
        console.log(err);
      });
  };

  const getFileName = async () => {
    setLoader(true);
    const obj = {
      intervieweeid: params?.id,
      formid: data?.id,
    };
    await ApiHelper.post(API.downloadForm, obj)
      .then((resData) => {
        console.log(resData);
        if (resData?.data?.success === true) {
          setFilename(resData?.data?.i9Doc);
        }
        setLoader(false);
      })
      .catch((err) => {
        setLoader(false);
        console.log(err);
      });
  };
  //update Field values
  const onTextAreaBlur = async (e) => {
    console.log(e);
    setLoader(true);
    const obj = {
      form_id: formId,
      field_label: e.target.name,
      interviewee_answer: e.target.value,
    };
    await ApiHelper.post(API.updateFields, obj)
      .then((resData) => {
        console.log(resData);
      })
      .catch((err) => {
        setLoader(false);
        console.log(err);
      });
  };

  // display value
  const generatevalue = (fieldName) => {
    let obj = formData.filter((item) => item?.label === fieldName);
    // console.log(obj)
    if (obj[0]?.answer === null) {
      return "";
    } else return obj[0]?.answer;
  };

  // onchange
  const onTextareaChange = (e) => {
    const updatedItems = formData.map((item) => {
      if (item.label === e.target.name) {
        return { ...item, answer: e.target.value };
      }
      return item;
    });
    setFormData(updatedItems);
  };

  //submit form
  const submitForm = async (e) => {
    e.preventDefault();
    setLoader(true);
    let err = false;
    for (let i = 0; i < formData.length; i++) {
      if (
        formData[i]?.label === "w4_firstname" ||
        formData[i]?.label === "w4_lastname" ||
        formData[i]?.label === "w4_address" ||
        formData[i]?.label === "w4_city" ||
        formData[i]?.label === "w4_checkbox" ||
        formData[i]?.label === "w4_sign"
        // formData[i]?.label==="w4_date"
      ) {
        if (formData[i]?.answer === "" || formData[i]?.answer === null) {
          err = true;
        }
      }
      if (formData[i]?.label === "w4_ss_NO") {
        console.log(typeof formData[i]?.answer);
        let ssnRegex = /^\d{3}-?\d{2}-?\d{4}$/.test(formData[i]?.answer);
        console.log(ssnRegex);
        if (
          formData[i]?.answer === "" ||
          formData[i]?.answer === null ||
          ssnRegex === false
        ) {
          err = true;
        }
      }
      if (isReview) {
        if (
          formData[i]?.label === "w4_emp_name_address" ||
          formData[i]?.label === "w4_emp_first_day_employment"
        ) {
          if (formData[i]?.answer === "" || formData[i]?.answer === null) {
            err = true;
          }
        }
      }
    }
    console.log(err);
    setError(err);
    const ChatbotId = localStorage.getItem("candidateChatbotId");
    let user = JSON.parse(localStorage.getItem("UserData"));
    if (err === true) {
      toast("Form Not Completed!", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      setLoader(false);
    } else {
      if (!isReview) {
        const formobj = {
          form_id: formId,
          field_label: "w4_date",
          interviewee_answer: moment().format("MMMM DD, YYYY"),
        };
        await ApiHelper.post(API.updateFields, formobj)
          .then((resData) => {
            console.log(resData);
          })
          .catch((err) => {
            setLoader(false);
            console.log(err);
          });
      }
      let obj = {
        formid: data.id,
        interviewid: params.id,
        template_id: params.tempid !== undefined ? params.tempid : 0,
      };
      let formData = {
        chatbotid: ChatbotId,
        intervieweeid: params?.id,
        formid: data?.id,
        userId: user?.id,
        template_id:
          tempId !== 0
            ? tempId
            : location.state?.tempId !== null
            ? location.state?.tempId
            : 0,
      };
      await ApiHelper.post(
        isReview ? API.employerConfirm : API.confirmForm,
        isReview ? formData : obj
      )
        .then((resData) => {
          console.log(resData);
          if (resData.data.success === true) {
            fetchSections(params.id);
            let filepath = API.legalFormsView + resData?.data?.pdfurl;
            if (!isReview && resData?.data?.pdfurl !== "") {
              const link = document.createElement("a");
              link.href = filepath;
              link.download = "avenu";
              link.target = "_blank";
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
            }
            toast("Form Completed!", {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            });

            // if(item.section_forms?.length === i + 1)
            //  {
            //     setNextInd(index+1)
            //  }
            setLoader(false);
          }
        })
        .catch((err) => {
          setLoader(false);
          console.log(err);
        });
    }
  };

  return (
    <div>
      <div className="mx-auto" style={{ width: "95%" }}>
        <div class="row justify-content-center">
          <div class="col-lg-12">
            <div class="me-3 mb-4 rev-padd-tap">
              <div>
                <p className="head-l">
                  <span>
                    <strong>Employee’s Withholding Certificate</strong>
                  </span>
                </p>
                <p className="head-l">
                  <strong>
                    Complete Form W-4 so that your employer can withhold the
                    correct federal income tax from your pay.
                  </strong>
                </p>
                <p className="head-l">
                  <strong>Give Form W-4 to your employer. </strong>
                </p>
                <p className="head-l">
                  <strong>
                    Your withholding is subject to review by the IRS.
                  </strong>
                </p>
              </div>
            </div>
            <p className="para-fonts">
              <strong>Step 1: Enter Personal Information</strong>
            </p>
            <form>
              <div class="row g-3">
                <div class="col-md-6">
                  <label for="your-name" class="form-label">
                    ( a ) First name and middle initial{" "}
                  </label>
                  <textarea
                    class="form-control text-class"
                    style={{
                      border:
                        error === true &&
                        (generatevalue("w4_firstname") === "" ||
                          generatevalue("w4_firstname") === null)
                          ? "1px solid red"
                          : null,
                    }}
                    id="your-message"
                    name="w4_firstname"
                    rows="5"
                    value={generatevalue("w4_firstname")}
                    onBlur={(e) => {
                      !isReview &&
                        data?.completed_status === 0 &&
                        onTextAreaBlur(e);
                    }}
                    onChange={(e) => {
                      !isReview &&
                        data?.completed_status === 0 &&
                        onTextareaChange(e);
                    }}
                  />
                </div>

                <div class="col-md-6">
                  <label for="your-surname" class="form-label">
                    Last name{" "}
                  </label>
                  <textarea
                    class="form-control text-class"
                    style={{
                      border:
                        error === true &&
                        (generatevalue("w4_lastname") === "" ||
                          generatevalue("w4_lastname") === null)
                          ? "1px solid red"
                          : null,
                    }}
                    id="your-message"
                    name="w4_lastname"
                    rows="5"
                    value={generatevalue("w4_lastname")}
                    onBlur={(e) => {
                      !isReview &&
                        data?.completed_status === 0 &&
                        onTextAreaBlur(e);
                    }}
                    onChange={(e) => {
                      !isReview &&
                        data?.completed_status === 0 &&
                        onTextareaChange(e);
                    }}
                  />
                </div>

                <div class="col-md-6">
                  <label for="your-email" class="form-label">
                    Address
                  </label>
                  <textarea
                    class="form-control text-class"
                    style={{
                      border:
                        error === true &&
                        (generatevalue("w4_address") === "" ||
                          generatevalue("w4_address") === null)
                          ? "1px solid red"
                          : null,
                    }}
                    id="your-message"
                    name="w4_address"
                    rows="5"
                    value={generatevalue("w4_address")}
                    onBlur={(e) => {
                      !isReview &&
                        data?.completed_status === 0 &&
                        onTextAreaBlur(e);
                    }}
                    onChange={(e) => {
                      !isReview &&
                        data?.completed_status === 0 &&
                        onTextareaChange(e);
                    }}
                  />
                </div>

                <div class="col-md-6">
                  <label for="your-subject" class="form-label">
                    City or town,state, and ZIP code
                  </label>
                  <textarea
                    class="form-control text-class"
                    id="your-message"
                    style={{
                      border:
                        error === true &&
                        (generatevalue("w4_city") === "" ||
                          generatevalue("w4_city") === null)
                          ? "1px solid red"
                          : null,
                    }}
                    name="w4_city"
                    rows="5"
                    value={generatevalue("w4_city")}
                    onBlur={(e) => {
                      !isReview &&
                        data?.completed_status === 0 &&
                        onTextAreaBlur(e);
                    }}
                    onChange={(e) => {
                      !isReview &&
                        data?.completed_status === 0 &&
                        onTextareaChange(e);
                    }}
                  />
                </div>

                <div class="col-md-6">
                  <label for="your-subject" class="form-label">
                    ( b ) Social security number
                  </label>
                  <div class="input-group-append pass-div-width">
                    <input
                      type={formData[6]?.isShow === true ? "text" : "password"}
                      class="form-control pass-inpt"
                      placeholder="Enter text here"
                      style={{
                        border:
                          error === true &&
                          (generatevalue("w4_ss_NO") === "" ||
                            generatevalue("w4_ss_NO") === null ||
                            /^\d{3}-?\d{2}-?\d{4}$/.test(
                              generatevalue("w4_ss_NO")
                            ) === false)
                            ? "1px solid red"
                            : null,
                        borderRight: "none",
                      }}
                      id="your-message"
                      name="w4_ss_NO"
                      rows="5"
                      value={generatevalue("w4_ss_NO")}
                      onBlur={(e) => {
                        !isReview &&
                          data?.completed_status === 0 &&
                          onTextAreaBlur(e);
                      }}
                      onChange={(e) => {
                        !isReview &&
                          data?.completed_status === 0 &&
                          onTextareaChange(e);
                      }}
                    />
                    <button
                      type="button"
                      class="btn eye-bttn"
                      data-toggle="password"
                      style={{
                        border:
                          error === true &&
                          (generatevalue("w4_ss_NO") === "" ||
                            generatevalue("w4_ss_NO") === null ||
                            /^\d{3}-?\d{2}-?\d{4}$/.test(
                              generatevalue("w4_ss_NO")
                            ) === false)
                            ? "1px solid red"
                            : null,
                        borderLeft: "none",
                      }}
                      onClick={() => {
                        let data = [...formData];
                        if (data) {
                          data[6].isShow = !data[6].isShow;
                        }
                        setFormData(data);
                      }}
                    >
                      <img
                        src={formData[6]?.isShow ? eyeview : eye}
                        alt="test"
                        className="menu_icon eye-img"
                      />
                    </button>
                  </div>
                  {/* <textarea class="form-control text-class" style={{ border: error===true && (generatevalue("w4_ss_NO") === "" || generatevalue("w4_ss_NO") === null || /^\d{3}-?\d{2}-?\d{4}$/.test(generatevalue("w4_ss_NO"))===false) ? '1px solid red' : null}} id="your-message" name="w4_ss_NO" rows="5" value={generatevalue("w4_ss_NO")} onBlur={(e)=>{(!isReview && data?.completed_status===0) && onTextAreaBlur(e)}} onChange={(e)=>{(!isReview && data?.completed_status===0) && onTextareaChange(e)}} /> */}
                </div>

                <div class="col-12">
                  <p className="para-fonts">( c )</p>
                  <input
                    type="radio"
                    class="form-check-input radio-sizee"
                    style={{
                      border:
                        error === true &&
                        (generatevalue("w4_checkbox") === "" ||
                          generatevalue("w4_checkbox") === null)
                          ? "1px solid red"
                          : null,
                    }}
                    name="w4_checkbox"
                    value="Single or Married filing separately"
                    onChange={(e) => {
                      if (!isReview && data?.completed_status === 0) {
                        onTextareaChange(e);
                        onTextAreaBlur(e);
                      }
                    }}
                    checked={
                      generatevalue("w4_checkbox") ===
                      "Single or Married filing separately"
                    }
                  />
                  <label for="vehicle1" className=" w4form-l">
                    {" "}
                    Single or Married filing separately
                  </label>
                </div>

                <div class="col-12">
                  <input
                    type="radio"
                    class="form-check-input radio-sizee"
                    style={{
                      border:
                        error === true &&
                        (generatevalue("w4_checkbox") === "" ||
                          generatevalue("w4_checkbox") === null)
                          ? "1px solid red"
                          : null,
                    }}
                    name="w4_checkbox"
                    value="Married filing jointly or Qualifying surviving spouse"
                    onChange={(e) => {
                      if (!isReview && data?.completed_status === 0) {
                        onTextareaChange(e);
                        onTextAreaBlur(e);
                      }
                    }}
                    checked={
                      generatevalue("w4_checkbox") ===
                      "Married filing jointly or Qualifying surviving spouse"
                    }
                  />
                  <label for="vehicle2" className=" w4form-l">
                    {" "}
                    Married filing jointly or Qualifying surviving spouse
                  </label>
                </div>

                <div class="col-12">
                  <input
                    type="radio"
                    class="form-check-input radio-sizee"
                    style={{
                      border:
                        error === true &&
                        (generatevalue("w4_checkbox") === "" ||
                          generatevalue("w4_checkbox") === null)
                          ? "1px solid red"
                          : null,
                    }}
                    name="w4_checkbox"
                    value="Head of household (Check only if you’re unmarried and pay more than half the costs of keeping up a home for yourself and a qualifying individual.)"
                    onChange={(e) => {
                      if (!isReview && data?.completed_status === 0) {
                        onTextareaChange(e);
                        onTextAreaBlur(e);
                      }
                    }}
                    checked={
                      generatevalue("w4_checkbox") ===
                      "Head of household (Check only if you’re unmarried and pay more than half the costs of keeping up a home for yourself and a qualifying individual.)"
                    }
                  />
                  <label for="vehicle3" className=" w4form-l">
                    {" "}
                    Head of household (Check only if you're unmarried and pay
                    more than half the costs of keeping up a home for yourself
                    and a qualifying individual.)
                  </label>
                </div>

                <h6 className="mb-0">
                  {" "}
                  <strong>
                    Complete Steps 2-4 ONLY if they apply to you; otherwise,
                    skip to Step 5.
                  </strong>
                  See page 2 for more information on each step, who can claim
                  exemption from withholding, other details, and privacy.
                </h6>
                <p className="para-fonts">
                  <strong>Step 2: Multiple Jobs or Spouse Works</strong>
                </p>
                <p className="para-fonts">
                  Complete this step if you (1) hold more than one job at a
                  time, or (2) are married filing jointly and your spouse also
                  works. The correct amount of withholding depends on income
                  earned from all of these jobs.
                </p>
                <p className="para-fonts">
                  Do <strong>only one</strong> of the following.
                </p>
                <p className="para-fonts">( a ) Reserved for future use.</p>
                <p className="para-fonts">
                  ( b ) Use the Multiple Jobs Worksheet on page 3 and enter the
                  result in Step 4(c ) below;<strong>or</strong>
                </p>
                <p className="para-fonts">
                  <strong>( c )</strong> If there are only two jobs total, you
                  may check this box. Do the same on Form W-4 for the other job.
                  This option is generally more accurate than ( b ) if you pay
                  at a lower paying job is more than half of the pay at the high
                  paying job. Otherwise, ( b ) is more accurate
                  {generatevalue("w4_step2_c_checkbox") !== undefined && (
                    <>
                      . . . . . . . . . . . . . . .{" "}
                      <input
                        type="checkbox"
                        id="vehicle1"
                        name="w4_step2_c_checkbox"
                        value={
                          generatevalue("w4_step2_c_checkbox") === "N/A" ||
                          generatevalue("w4_step2_c_checkbox") === "" ||
                          generatevalue("w4_step2_c_checkbox") === null
                            ? "true"
                            : "N/A"
                        }
                        style={{
                          border:
                            error === true &&
                            (generatevalue("w4_step2_c_checkbox") === "N/A" ||
                              generatevalue("w4_step2_c_checkbox") === "" ||
                              generatevalue("w4_step2_c_checkbox") === null)
                              ? "1px solid red"
                              : null,
                        }}
                        onChange={(e) => {
                          if (!isReview && data?.completed_status === 0) {
                            onTextareaChange(e);
                            onTextAreaBlur(e);
                          }
                        }}
                        checked={
                          generatevalue("w4_step2_c_checkbox") === "true"
                        }
                      />
                    </>
                  )}
                </p>
                <h6 className="mb-0">
                  {" "}
                  <strong>
                    Complete Steps 3-4 ( b ) on Form W-4 for only ONE of the
                    those jobs..
                  </strong>
                  Leave those steps blank for the other jobs. (Your withholding
                  will be most accurate if you complete Steps 3–4(b) on the Form
                  W-4 for the highest paying job.)
                </h6>
                <p className="para-fonts">
                  <strong>Step 3: Claim Dependent and Other Credits</strong>
                </p>
                <p className="para-fonts">
                  If your total income will be $200,000 or less ($400,000 or
                  less if married filing jointly):{" "}
                </p>

                <div class="col-md-6">
                  <p className="para-fonts">
                    <span className="mul-txt">
                      Multiply the number of qualifiying children under age 17
                      by $2,000
                    </span>
                    &nbsp;
                  </p>
                  <textarea
                    class="form-control text-class"
                    id="your-message"
                    name="w4_step3_a"
                    rows="5"
                    value={generatevalue("w4_step3_a")}
                    onBlur={(e) => {
                      !isReview &&
                        data?.completed_status === 0 &&
                        onTextAreaBlur(e);
                    }}
                    onChange={(e) => {
                      !isReview &&
                        data?.completed_status === 0 &&
                        /^\d*$/.test(e.target.value) &&
                        onTextareaChange(e);
                    }}
                  ></textarea>
                </div>

                <div class="col-md-6">
                  <p className="para-fonts">
                    <span className="mul-txt">
                      Multiply the number of other dependents by $500
                    </span>
                    &nbsp;
                  </p>
                  <textarea
                    class="form-control text-class"
                    id="your-message"
                    name="w4_step3_b"
                    rows="5"
                    value={generatevalue("w4_step3_b")}
                    onBlur={(e) => {
                      !isReview &&
                        data?.completed_status === 0 &&
                        onTextAreaBlur(e);
                    }}
                    onChange={(e) => {
                      !isReview &&
                        data?.completed_status === 0 &&
                        /^\d*$/.test(e.target.value) &&
                        onTextareaChange(e);
                    }}
                  ></textarea>
                </div>
                {/* <div class="col-md-6">
          <p className='para-fonts'><span className='mul-txt'>Multiply the number of other dependents by $500</span>&nbsp;</p>   
          <textarea class="form-control text-class" id="your-message" name="w4_step3_c" rows="5" value={generatevalue("w4_step3_c")} onBlur={(e)=>{onTextAreaBlur(e)}} onChange={(e)=>{onTextareaChange(e)}} ></textarea>
          </div> */}

                <div class="col-md-12">
                  <p className="para-fonts">
                    <span className="mul-txt">
                      Add the amounts of above for qualifying children and other
                      dependents. You may add to this the amount of any other
                      credits. Enter the total here{" "}
                    </span>
                    &nbsp;
                  </p>
                  <p className="para-fonts">
                    <span className="mul-txt">
                      ( 3 ) $ Enter the total here .{" "}
                    </span>
                    &nbsp;
                  </p>

                  <textarea
                    class="form-control text-class"
                    id="your-message"
                    name="w4_step3_c"
                    rows="5"
                    value={generatevalue("w4_step3_c")}
                    onBlur={(e) => {
                      !isReview &&
                        data?.completed_status === 0 &&
                        onTextAreaBlur(e);
                    }}
                    onChange={(e) => {
                      !isReview &&
                        data?.completed_status === 0 &&
                        /^\d*$/.test(e.target.value) &&
                        onTextareaChange(e);
                    }}
                  ></textarea>
                </div>
                <p className="para-fonts">
                  <strong>Step 4 (optional): Other Adjustments</strong>
                </p>

                <div class="col-md-12">
                  <p className="para-fonts">
                    <strong>( a ) Other income (not from jobs).</strong>
                    <span className="mul-txt">
                      If you want tax withheld for other income you expect this
                      year that won’t have withholding, enter the amount of
                      other income here. This may include interest, dividends,
                      and retirement income .{" "}
                    </span>
                    &nbsp;
                  </p>
                  <p className="para-fonts">4 ( a ) $</p>
                  <textarea
                    class="form-control text-class"
                    id="your-message"
                    name="w4_step_4(a)"
                    rows="5"
                    value={generatevalue("w4_step_4(a)")}
                    onBlur={(e) => {
                      !isReview &&
                        data?.completed_status === 0 &&
                        onTextAreaBlur(e);
                    }}
                    onChange={(e) => {
                      !isReview &&
                        data?.completed_status === 0 &&
                        /^\d*$/.test(e.target.value) &&
                        onTextareaChange(e);
                    }}
                  ></textarea>
                </div>

                <div class="col-md-12">
                  <p className="para-fonts">
                    <strong>( b ) Deductions.</strong>
                    <span className="mul-txt">
                      {" "}
                      If you expect to claim deductions other than the standard
                      deduction and want to reduce your withholding, use the
                      Deductions Worksheet on page 3 and enter the result here.{" "}
                    </span>
                    &nbsp;
                  </p>
                  <p className="para-fonts">4 ( b ) $</p>
                  <textarea
                    class="form-control text-class"
                    id="your-message"
                    name="w4_step_4(b)"
                    rows="5"
                    value={generatevalue("w4_step_4(b)")}
                    onBlur={(e) => {
                      !isReview &&
                        data?.completed_status === 0 &&
                        onTextAreaBlur(e);
                    }}
                    onChange={(e) => {
                      !isReview &&
                        data?.completed_status === 0 &&
                        /^\d*$/.test(e.target.value) &&
                        onTextareaChange(e);
                    }}
                  ></textarea>
                </div>

                <div class="col-md-12">
                  <p className="para-fonts">
                    <strong>( c ) Extra withholding.</strong>
                    <span className="mul-txt">
                      Enter any additional tax you want withheld each pay period{" "}
                    </span>
                    &nbsp;
                  </p>
                  <p className="para-fonts">4 ( c ) $</p>
                  <textarea
                    class="form-control text-class"
                    id="your-message"
                    name="w4_step_4(c)"
                    rows="5"
                    value={generatevalue("w4_step_4(c)")}
                    onBlur={(e) => {
                      !isReview &&
                        data?.completed_status === 0 &&
                        onTextAreaBlur(e);
                    }}
                    onChange={(e) => {
                      !isReview &&
                        data?.completed_status === 0 &&
                        /^\d*$/.test(e.target.value) &&
                        onTextareaChange(e);
                    }}
                  ></textarea>
                </div>

                <p className="para-fonts">
                  <strong>Step 5 : Sign Here</strong>
                </p>
                <p className="para-fonts">
                  Under penalties of perjury, I declare that this certificate,
                  to the best of my knowledge and belief, is true, correct, and
                  complete.
                </p>

                <div class="col-6">
                  <div class="form-floating wraper minH mb-3">
                    <input
                      type="text"
                      class="form-control signs"
                      style={{
                        border:
                          error === true &&
                          (generatevalue("w4_sign") === "" ||
                            generatevalue("w4_sign") === null)
                            ? "1px solid red"
                            : null,
                      }}
                      id="signHereInput"
                      placeholder="name@example.com"
                      name="w4_sign"
                      value={generatevalue("w4_sign")}
                      onBlur={(e) => {
                        !isReview &&
                          data?.completed_status === 0 &&
                          onTextAreaBlur(e);
                      }}
                      onChange={(e) => {
                        !isReview &&
                          data?.completed_status === 0 &&
                          onTextareaChange(e);
                      }}
                    />
                    <label for="signHereInput" class=" font-enter-color">
                      Sign Here
                    </label>
                  </div>
                </div>

                <div class="col-6">
                  <div class="form-floating minH mb-3">
                    <input
                      class="form-control"
                      name="w4_date"
                      value={
                        generatevalue("w4_date") === "" ||
                        generatevalue("w4_date") === undefined
                          ? moment().format("MMMM DD, YYYY")
                          : generatevalue("w4_date")
                      }
                    />
                    <label for="dateInput" class=" font-enter-color">
                      Date
                    </label>
                  </div>
                </div>

                {/* <div class="col-md-6">
          <p className='para-fonts'>Date&nbsp;</p>   
          <textarea class="form-control text-class" id="your-message" name="your-message" rows="5" required></textarea>
          </div> */}

                {isReview && (
                  <>
                    <p className="head-l mt-5 mb-4">
                      <span>
                        <strong>Employers Only.</strong>
                      </span>
                    </p>

                    <div class="col-md-6">
                      <p className="para-fonts">
                        Employers name and address&nbsp;
                      </p>
                      <textarea
                        class="form-control text-class"
                        style={{
                          border:
                            error === true &&
                            (generatevalue("w4_emp_name_address") === "" ||
                              generatevalue("w4_emp_name_address") === null)
                              ? "1px solid red"
                              : null,
                        }}
                        id="your-message"
                        name="w4_emp_name_address"
                        rows="5"
                        value={generatevalue("w4_emp_name_address")}
                        onBlur={(e) => {
                          if (data?.employer_status === 0) {
                            onTextAreaBlur(e);
                          }
                        }}
                        onChange={(e) => {
                          if (data?.employer_status === 0) {
                            onTextareaChange(e);
                          }
                        }}
                      ></textarea>
                    </div>

                    <div class="col-md-6">
                      <p className="para-fonts">
                        First date of employment&nbsp;
                      </p>
                      <textarea
                        class="form-control text-class"
                        style={{
                          border:
                            error === true &&
                            (generatevalue("w4_emp_first_day_employment") ===
                              "" ||
                              generatevalue("w4_emp_first_day_employment") ===
                                null)
                              ? "1px solid red"
                              : null,
                        }}
                        id="your-message"
                        name="w4_emp_first_day_employment"
                        rows="5"
                        value={generatevalue("w4_emp_first_day_employment")}
                        onBlur={(e) => {
                          if (data?.employer_status === 0) {
                            onTextAreaBlur(e);
                          }
                        }}
                        onChange={(e) => {
                          if (data?.employer_status === 0) {
                            onTextareaChange(e);
                          }
                        }}
                      ></textarea>
                    </div>

                    <div class="col-md-6 mb-3">
                      <p className="para-fonts">
                        Employer Identification Number (EIN)&nbsp;
                      </p>
                      <textarea
                        class="form-control text-class"
                        id="your-message"
                        name="w4_emp_EIN"
                        rows="5"
                        value={generatevalue("w4_emp_EIN")}
                        onBlur={(e) => {
                          if (data?.employer_status === 0) {
                            onTextAreaBlur(e);
                          }
                        }}
                        onChange={(e) => {
                          if (data?.employer_status === 0) {
                            onTextareaChange(e);
                          }
                        }}
                      ></textarea>
                    </div>
                  </>
                )}

                {data.completed_status === 0 && !isReview && (
                  <div className="col-lg-12  align-items-center justify-content-end">
                    <div className="form-floating mb-3 justify-content-end wraper">
                      <button
                        className="submits-btn rounded p-2"
                        onClick={(e) => {
                          submitForm(e);
                        }}
                      >
                        {/* {item.section_forms?.length === i + 1 ? 'Submit Form' : 'Next Form'}  */}
                        Submit Form
                      </button>
                    </div>
                  </div>
                )}

                {data?.completed_status === 1 &&
                  data.employer_status === 0 &&
                  isReview && (
                    <div className="col-lg-12  align-items-center justify-content-end">
                      <div className="form-floating mb-3 justify-content-end wraper">
                        <button
                          className="submits-btn rounded p-2"
                          onClick={(e) => {
                            e.preventDefault();
                            submitForm(e);
                          }}
                        >
                          {" "}
                          Confirm Form{" "}
                        </button>
                      </div>
                    </div>
                  )}
                {data?.employer_status === 1 && isReview && fileName !== "" && (
                  <div className="col-lg-12  align-items-center justify-content-end">
                    <div className="form-floating mb-3 justify-content-end wraper">
                      <button
                        className="submits-btn rounded p-2 sub-bttn-right-sides"
                        onClick={(e) => {
                          e.preventDefault();
                          let filepath = API.legalFormsView + fileName;
                          if (fileName !== "") {
                            const link = document.createElement("a");
                            link.href = filepath;
                            link.download = "avenu";
                            link.target = "_blank";
                            document.body.appendChild(link);
                            link.click();
                            document.body.removeChild(link);
                          }
                        }}
                      >
                        Download{" "}
                      </button>

                      {/* <button className='submits-btn rounded p-2 sub-bttn-right-sides' 
                                                                    onClick={(e) => { submitForm(e, 'Updated') }}> Update Form </button> */}
                    </div>
                  </div>
                )}

                {/* <p className='para-fonts'>Step 2(b) - Multiple Jobs Worksheet (Optional)</p>
          <p className='para-fonts'>(Keep for your records.)</p>
          <p className='para-fonts'>If you choose the option in Step 2(b) on Form W-4, complete this worksheet
             (which calculates the total extra tax for all jobs) on only<strong> ONE </strong>
             Form W-4. Withholding will be most accurate if you complete the worksheet 
             and enter the result on the Form W-4 for the highest paying job. 
             To be accurate, submit a new Form W-4 for all other jobs if you have 
             not updated your withholding since 2019</p>
             
             <p className='para-fonts'><strong>Note: </strong>If more than one job has annual wages of more than $120,000 or
              there are more than three jobs, see Pub. 505 for additional tables; or, you can use the
               online withholding estimator at <a href="" target="_self">www.irs.gov/W4App</a>.</p>

               <p className='para-fonts'><strong>1 Two jobs.</strong> <span className='mul-txt'>“Lower Paying Job” column, find the value at the intersection of the two household salaries and enter</span>
               <span className='mul-txt'>that value on line 1. Then, skip to line 3.</span>&nbsp;</p>
         
               <div class="col-md-6">
                <textarea class="form-control text-class" id="your-message" name="your-message" rows="5" required></textarea>
              </div>
              <p className='para-fonts'><strong>2 Three jobs.</strong> If you and/or your spouse have three jobs at the same time, complete lines 2a, 2b, and 2c below. Otherwise, skip to line 3.&nbsp;</p>
              <p className='para-fonts'><strong>2a</strong> Find the amount from the appropriate table on page 4 using the annual wages from the highest
paying job in the “Higher Paying Job” row and the annual wages for your next highest paying job
in the “Lower Paying Job” column. Find the value at the intersection of the two household salaries
and enter that value on line 2a  .&nbsp;</p>
<div class="col-md-6">
                <textarea class="form-control text-class" id="your-message" name="your-message" rows="5" required></textarea>
              </div>
              <p className='para-fonts'><strong>2b</strong>Add the annual wages of the two highest paying jobs from line 2a together and use the total as the
wages in the “Higher Paying Job” row and use the annual wages for your third job in the “Lower
Paying Job” column to find the amount from the appropriate table on page 4 and enter this amount
on line 2b </p>
<div class="col-md-6">
                <textarea class="form-control text-class" id="your-message" name="your-message" rows="5" required></textarea>
              </div>

              <p className='para-fonts'><strong>2c</strong> Add the amounts from lines 2a and 2b and enter the result on line 2c </p>
              <div class="col-md-6">
                <textarea class="form-control text-class" id="your-message" name="your-message" rows="5" required></textarea>
              </div>

              <p className='para-fonts'><strong>3</strong> Enter the number of pay periods per year for the highest paying job. For example, if that job pays
weekly, enter 52; if it pays every other week, enter 26; if it pays monthly, enter 12, etc  </p>
              <div class="col-md-6">
                <textarea class="form-control text-class" id="your-message" name="your-message" rows="5" required></textarea>
              </div>

              <p className='para-fonts'><strong>4 Divide</strong> the annual amount on line 1 or line 2c by the number of pay periods on line 3. Enter this
amount here and in <strong>Step 4( c ) </strong> of Form W-4 for the highest paying job (along with any other additional
amount you want withheld) </p>
              <div class="col-md-6">
                <textarea class="form-control text-class" id="your-message" name="your-message" rows="5" required></textarea>
              </div>
              <p className='para-fonts'><strong>Step 4(b) - Deductions Worksheet (Optional)</strong></p>
              < p className='para-fonts'>(Keep for your records.)</p>

              <p className='para-fonts'><strong>1</strong>  Enter an estimate of your 2024 itemized deductions (from Schedule A (Form 1040)). Such deductions
may include qualifying home mortgage interest, charitable contributions, state and local taxes (up to
$10,000), and medical expenses in excess of 7.5% of your income . </p>
              <div class="col-md-6">
                <textarea class="form-control text-class" id="your-message" name="your-message" rows="5" required></textarea>
              </div>

              <p className='para-fonts'><strong>2</strong>Enter:<strong>•</strong>$29,200 if you’re married filing jointly or a qualifying surviving spouse</p>
              <p className='para-fonts'><strong>•</strong>$21,900 if you’re head of household</p>
              <p className='para-fonts'><strong>•</strong> $14,600 if you’re single or married filing separately</p>
             
              <div class="col-md-6">
                <textarea class="form-control text-class" id="your-message" name="your-message" rows="5" required></textarea>
              </div>

              <p className='para-fonts'><strong>3</strong>  If line 1 is greater than line 2, subtract line 2 from line 1 and enter the result here. If line 2 is greater
than line 1, enter “-0-”  </p>
              <div class="col-md-6">
                <textarea class="form-control text-class" id="your-message" name="your-message" rows="5" required></textarea>
              </div>

              <p className='para-fonts'><strong>4</strong>  Enter an estimate of your student loan interest, deductible IRA contributions, and certain other
adjustments (from Part II of Schedule 1 (Form 1040)). See Pub. 505 for more information .   </p>
              <div class="col-md-6">
                <textarea class="form-control text-class" id="your-message" name="your-message" rows="5" required></textarea>
              </div>

              <p className='para-fonts'><strong>5</strong> Add lines 3 and 4. Enter the result here and in <strong>Step 4(b)</strong>  of Form W-4  </p>
              <div class="col-md-6 mb-3">
                <textarea class="form-control text-class" id="your-message" name="your-message" rows="5" required></textarea>
              </div>*/}
              </div>
            </form>
          </div>
        </div>
      </div>

      <ToastContainer
        position="top-right"
        autoClose={4000}
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </div>
  );
};

export default W4form;
